/**
 * Arduino Custom Dropdown Menu
 */

class Menu {
    constructor(container, toggle, clickAway = true) {
        this.container = container;
        this.toggle = toggle;
        this.clickAway = clickAway;
    }

    onToggleClick(event) {
        this.container.classList.toggle('visible');
        this.toggle.ariaExpanded = this.toggle.ariaExpanded == 'true' ? 'false' : 'true';
    }

    onClickAway(event) {
        if(this.toggle != event.target.closest('button')) {
            this.container.classList.remove('visible');
            this.toggle.ariaExpanded = 'false';
        }
    }

    onKeyDown(event) {
        if(event.key == 'Escape') {
            this.container.classList.remove('visible');
            this.toggle.ariaExpanded = 'false';
        }
    }

    init() {
        // toggle click
        this.toggle.addEventListener('click', (event) => { this.onToggleClick(event) });

        // on click away
        if(this.clickAway) {
            window.addEventListener('click', (event) => { this.onClickAway(event) });
        }

        // for keyboard users
        window.addEventListener('keydown', (event) => { this.onKeyDown(event) });
    }
}

(function() {
    window.addEventListener('load', () => {
        // desktop
        const dropDownToggles = document.querySelectorAll('.ino-menu__toggle');
        const menus = [];

        for(let toggle of dropDownToggles) {
            const container = toggle.parentElement;

            const menu = new Menu(container, toggle);
            menu.init();

            menus.push(menu);
        }

        // mobile
        const burgerMenuToggle = document.querySelector('.ino-header__hamburger');
        const burgerMenuContainer = document.querySelector('.ino-header__menu--mobile');

        const burgerMenu = new Menu(burgerMenuContainer, burgerMenuToggle, false);
        burgerMenu.init();

        menus.push(burgerMenu);

        // account menu
        const accountMenuToggle = document.querySelectorAll('.ino-account-menu__toggle');

        for(let toggle of accountMenuToggle) {
            const container = toggle.parentElement;

            const menu = new Menu(container, toggle);
            menu.init();

            menus.push(menu);
        }
    })
})();